import 'flickity/dist/flickity.pkgd.js'
import 'flickity-fade/flickity-fade.js'

$('.carousel').flickity({
	cellAlign: 'left',
	contain: true,
	pageDots: false,
	adaptiveHeight: true,
	wrapAround: true,
	autoPlay: 4000,
	arrowShape: 'M24.8,29.4C31.5,21.1,37.3,11.3,42.4,0L45.5,1.3C42.6,9.3,39.4,16.2,36.1,22C32.800000000000004,27.8,29.3,32.9,25.700000000000003,37.3S18.1,45.699999999999996,13.800000000000002,49.4C18.1,53.1,22.1,57.199999999999996,25.700000000000003,61.7C29.300000000000004,66.2,32.800000000000004,71.5,36.1,77.5C39.4,83.5,42.5,90.6,45.5,98.7L42.4,100C37.4,88.7,31.5,78.9,24.799999999999997,70.6S9.8,55.5,0,50.1V49.9C9.8,44.5,18.1,37.7,24.8,29.4 Z'
})

var numHomeSlides = $('.carousel--home__slide').length
var homeSlideRandom = Math.floor(Math.random() * (numHomeSlides - 0 + 1));

$('.carousel--home').flickity({
	pageDots: false,
	adaptiveHeight: false,
	prevNextButtons: false,
	autoPlay: 8000,
	pauseAutoPlayOnHover: false,
	initialIndex: homeSlideRandom,
	draggable: false,
	fade: true
})